import React, {Component} from 'react';
import {Link, Redirect} from 'react-router-dom';
import leftMan from '../icons/ampelL.png';
import rightMan from '../icons/ampelR.png';

let maxHeight = 0.9;
let maxWidthDesk = 0.75;
let maxWidthMobile = 0.8;
let navWidth = 259;

export default class SingleImage extends Component {
  constructor(props) {
    super(props);

    this.onResize = this.onResize.bind(this);

    this.state = {
      clickHeight: '300',
      prev: null,
      next: null,
      maxH: 700,
      maxW: 700,
      mobile: false,
      maxMobileH: 500,
      maxMobileW: 500,
    }
  }

  componentDidMount() {
    this.props.toggleWork(true);
    this.onResize();
    window.addEventListener('resize', this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize() {
    let h = window.innerHeight;
    let w = window.innerWidth;
    let wDesk = window.innerWidth-navWidth;
    let maxH = Math.floor(h*maxHeight);
    let maxW = Math.floor(wDesk*maxWidthDesk);
    let wMobile = Math.floor(w*maxWidthMobile);
    let cH = Math.min(this.props.height, maxH);

    if (cH < 50) {
      cH = window.innerHeight*maxHeight;
    }

    if (this.props.width >= maxW) {
      cH = this.props.height/(this.props.width/maxW);
    }

    this.setState({
      maxH: maxH, maxW: maxW, mobile: w <= 768,
      clickHeight: cH, maxMobileH: maxH, maxMobileW: Math.min(wMobile, w-150)
    });
  }

  render() {
    if (this.state.prev) {
      return <Redirect push to={this.state.prev} />
    }

    if (this.state.next) {
      return <Redirect push to={this.state.next} />
    }

    let browserStyle = {
      'maxHeight': this.state.maxH + 'px',
      'maxWidth': this.state.maxW + 'px'
    }

    let mobileStyle = {
      'maxHeight': this.state.maxMobileH + 'px',
      'maxWidth': this.state.maxMobileW + 'px'
    }

    let heightStyle = {
      'height': this.state.clickHeight + 'px'    }

    return (
      this.state.mobile
      ?
      // mobile single image
      <div className='single-image-container-mobile'>
        <img
          className='single-image-mobile-left'
          src={leftMan}
          alt='left click'
          onClick={() => this.setState({prev: this.props.section + '/' + this.props.prev})}
        />
        <div className='single-image-mobile'>
          <Link to={this.props.section}>
            <img
              src={this.props.src}
              style={mobileStyle}
              draggable={false}
            />
          </Link>
        </div>
        <img
          className='single-image-mobile-right'
          src={rightMan}
          alt='right click'
          onClick={() => this.setState({next: this.props.section + '/' + this.props.next})}
        />
      </div>
      :
      //desktop single image
      <div className='single-image-container'>
        <div className='single-image'>
          <Link to={this.props.section}>
            <img
              src={this.props.src}
              style={browserStyle}
              draggable={false}
            />
          </Link>
        </div>
        <div className='single-image-columns'>
          <div
            className='single-image-left-column'
            onClick={() => this.setState({prev: this.props.section + '/' + this.props.prev})}
            style={heightStyle}
          >
          </div>
          <div
            className='single-image-right-column'
            onClick={() => this.setState({next: this.props.section + '/' + this.props.next})}
            style={heightStyle}
          >
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SingleImage.js